/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Breadcrumbs } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import type { DomainFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

type Props = {
  domains?: Array<DomainFragment> | null;
};

const ConsumerBreadcrumbs = ({ domains }: Props) => {
  const eventingProductData = useEventingProductData();
  const track = useTracker();
  const { enableXDPRedesignPhase1, enableXDPRedesignHero } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignHero;

  const onClickBreadcrumbItem = (linkName: string) => () => {
    track('click_button', {
      button: { name: 'description_page_breadcrumb', linkName },
      ...eventingProductData,
    });
  };

  return (
    <Breadcrumbs>
      <Breadcrumbs.Item href="/" onClick={onClickBreadcrumbItem('homepage')}>
        {_t('Home')}
      </Breadcrumbs.Item>
      {!enableXDPRedesign && (
        <Breadcrumbs.Item href="/browse" onClick={onClickBreadcrumbItem('browse')}>
          {_t('Browse')}
        </Breadcrumbs.Item>
      )}
      {domains && domains.length > 0 && (
        // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        <Breadcrumbs.Item href={`/browse/${domains[0].domainId}`} onClick={onClickBreadcrumbItem('domain')}>
          {/*
           // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess */}
          {domains[0].domainName}
        </Breadcrumbs.Item>
      )}
      {/*
       // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess */}
      {domains && domains.length > 0 && domains[0].subdomainId && domains[0].subdomainName && (
        <Breadcrumbs.Item
          // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          href={`/browse/${domains[0].domainId}/${domains[0].subdomainId}`}
          onClick={onClickBreadcrumbItem('subdomain')}
        >
          {/*
           // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess */}
          {domains[0].subdomainName}
        </Breadcrumbs.Item>
      )}
    </Breadcrumbs>
  );
};

export default ConsumerBreadcrumbs;
